﻿<template>

    <header class="header mb-app-header">
        <header_menu></header_menu>
    </header>

    <main class="mb-shell">
        <div class="mb-page">
            <details_content></details_content>
        </div>
    </main>

</template>

<script lang="ts" src="./details.ts"></script>